import LoaderOverlay from 'components/LoaderOverlay'
import ThemeContext from 'components/ThemeContext'
import lodash, { map } from 'lodash'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { request } from 'utils'
import { updateSentryUser } from 'utils/initSentry'

import CustomerContext from './CustomerContext'

export { default as CustomerContext } from './CustomerContext'

export const CustomerContextProvider = (props) => {
  const { children } = props

  const [isLoading, setIsLoading] = useState(false)

  const [customers] = useState(lodash.get(global, 'allowedCustomerList', []))

  const [currentCustomer, setCurrentCustomer] = useState(
    lodash.get(global, 'currentCustomer'),
  )

  useEffect(() => {
    updateSentryUser({
      customerId: lodash.get(currentCustomer, 'id'),
      customerName: lodash.get(currentCustomer, 'postaladdress.name1'),
      customerRef1: lodash.get(currentCustomer, 'customerRef1'),
    })
  }, [currentCustomer])

  const theme = useMemo(() => {
    const tenant = global.tenantSettings

    const backgroundColor =
      lodash.get(currentCustomer, 'menuColor') ||
      lodash.get(tenant, 'returncolor') ||
      '#4a4949'

    const isDark = !isDarkColor(backgroundColor)

    return {
      backgroundColor,
      headerTextColor: '#36404a',
      linkColor:
        lodash.get(currentCustomer, 'menuFontColor') ||
        (isDark ? 'white' : '#36404a'),
      primaryColor:
        lodash.get(currentCustomer, 'boxFontColor') ||
        (isDark ? 'white' : '#36404a'),
      primaryBackgroundColor: backgroundColor,
      boxColor: lodash.get(currentCustomer, 'boxColor') || backgroundColor,
      boxFontColor:
        lodash.get(currentCustomer, 'boxFontColor') ||
        (isDark ? 'white' : '#36404a'),
    }
  }, [currentCustomer])

  const changeCustomer = async (id) => {
    try {
      setIsLoading(true)
      const { data } = await request({
        method: 'get',
        url: `/api/switchCustomer/${id}`,
      })
      if (!lodash.get(data, 'id')) {
        throw new Error('Invalid customer')
      }
      window.location.reload()
      // setCurrentCustomer(data)
    } catch (err) {
      toast.error(
        'Beim Wechsel der Benutzerkennung ist ein Fehler aufgetreten!',
      )
      console.error(err)
      setIsLoading(false)
    }
  }

  const presets = useMemo(() => {
    return map(lodash.get(currentCustomer, 'mappedPresets', []), (preset) => ({
      defaultWeight: 1,
      ...preset,
    }))
  }, [currentCustomer])

  return (
    <>
      <LoaderOverlay isLoading={isLoading} fullscreen />
      <CustomerContext.Provider
        value={{
          customers,
          currentCustomer,
          customer: currentCustomer,
          changeCustomer,
          theme,
          presets,
        }}
      >
        <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
      </CustomerContext.Provider>
    </>
  )
}

export const useCustomer = () => {
  const value = useContext(CustomerContext)
  return value
}

function isDarkColor(hexcolor) {
  hexcolor = hexcolor.replace('#', '')
  var r = parseInt(hexcolor.substr(0, 2), 16)
  var g = parseInt(hexcolor.substr(2, 2), 16)
  var b = parseInt(hexcolor.substr(4, 2), 16)
  var yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 128
}
